import React from 'react';
import PropTypes from 'prop-types';

import {
  Flex,
  Label,
  TextInput,
  Checkbox,
  InnerPanel
} from '@sopranodesign/pulse-components';

const IntegrationInput = ({ content, onChange }) => {
  const handleOnChange = event => {
    const value = event.target.value;

    onChange({ target: value });
  };

  const handleUseEntireResponseChange = () => {
    const newValue = !content.use_entire_response;

    onChange({ use_entire_response: newValue });
  };

  return (
    <InnerPanel>
      <Flex mb>
        <Checkbox
          checked={content.use_entire_response}
          onChange={handleUseEntireResponseChange}
          label="Use entire response"
        />
      </Flex>
      <Flex col>
        <Label htmlFor="target">Target</Label>
        <TextInput
          id="target"
          disabled={content.use_entire_response}
          value={content.target}
          onChange={handleOnChange}
          placeholder="body.users.0.name"
        />
      </Flex>
    </InnerPanel>
  );
};

IntegrationInput.propTypes = {
  content: PropTypes.shape({
    use_entire_response: PropTypes.bool.isRequired,
    target: PropTypes.string.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default IntegrationInput;
